import React from 'react';

const Education = () => {
    return (
      <div className="mt-12 mx-auto w-full ">
        <h1 className="text-center text-5xl mb-12 uppercase tracking-wide  text-black-400 font-semibold">
          Education
        </h1>
        <div className="flex flex-wrap justify-around items-center">
          <div className="card  w-96 bg-base-100 shadow-xl">
            <figure className="px-10 pt-10">
              <img src="Du.png" alt="Shoes" className="rounded-xl w-40" />
            </figure>
            <div className="card-body items-center text-center">
              <h2 className="card-title">University of Dhaka</h2>
              <p>BSS, Political Science and Government 2019 - 2024</p>
              <p className="mt-2 text-black-200">Undergraduation.</p>
              <div className="card-actions">
                <button className="btn btn-primary">
                  {" "}
                  <a target='blank' href="https://www.linkedin.com/in/solih-ahmad-sohan/#education">
                    Check More
                  </a>{" "}
                </button>
              </div>
            </div>
          </div>
          <div className="card mt-12  w-96 bg-base-100 shadow-xl">
            <figure className="px-10 pt-10">
              <img
                src="programminghero_logo.png"
                alt="programminghero"
                className="rounded-xl w-40"
              />
            </figure>
            <div className="card-body items-center text-center">
              <h2 className="card-title"> Programming Hero (Course)</h2>
              <p> Complete Web Development 2020-2021</p>
              <p className="mt-2 text-black-200">
                Finished With top 5% Performance
              </p>
              <div className="card-actions">
                <button className="btn btn-primary">
                  <a target='blank' href="https://www.linkedin.com/posts/solih-ahmad-sohan_alhamdulillah-activity-6963742791461994496-UO0c?utm_source=share&utm_medium=member_desktop"> Certificate</a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default Education;